import { render } from "./PSPDFKitContainer.vue?vue&type=template&id=64660e82"
import script from "./PSPDFKitContainer.vue?vue&type=script&lang=js"
export * from "./PSPDFKitContainer.vue?vue&type=script&lang=js"

import "./PSPDFKitContainer.vue?vue&type=style&index=0&id=64660e82&lang=scss"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__